import React from 'react';
import { trackClickCta } from '@jbhi-fi/utils/src/ga4Tracking';
import { styles } from './InstallTermsNote.css';
import { INSTALL_INCLUSIONS_AND_EXCLUSIONS_PATH, INSTALL_TERMS_PATH } from './utils';

type Props = {
  gtmSource: 'minicart' | 'cart' | 'slideout';
};

export const InstallTermsNote = ({ gtmSource }: Props) => {
  const handleTrack = (linkText: string, linkUrl: string) => () => {
    trackClickCta({ linkText, linkUrl, location: gtmSource });
  };

  return (
    <div>
      <a
        href={INSTALL_INCLUSIONS_AND_EXCLUSIONS_PATH}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
        onClick={handleTrack('View inclusions and exclusions', INSTALL_INCLUSIONS_AND_EXCLUSIONS_PATH)}
      >
        View inclusions and exclusions
      </a>

      <div className={styles.note} role="note">
        <strong>Heads up:</strong> Installs availability and pricing may differ in some areas. Price does not include
        delivery. Final pricing shown in checkout. For more information see the{' '}
        <a
          href={INSTALL_TERMS_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
          onClick={handleTrack('JB Hi-Fi Installation terms and conditions', INSTALL_TERMS_PATH)}
        >
          JB Hi-Fi Installation terms and conditions
        </a>
        .
      </div>
    </div>
  );
};
